export default "__VITE_ASSET__FcSAo2I3__"